import {InjectionToken} from '@angular/core';

export const LANG = new InjectionToken<string>('lang');
